import { Request } from '../utils';

const prefix = 'end_user';
const agreementPrefix = 'end_user_agreement_consent';
const pharmacyPrefix = 'end_user_pharmacy';
const addressPrefix = 'end_user_address';
const orderPrefix = 'order/end_user';
const supportPrefix = 'end_user_support';

/* GET End User List */
export const getCustomerList = queries => {
  const { limit, skip, orderBy, sortBy, name, surname, telephone, email } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!surname && params.append('surname', surname);
  !!telephone && params.append('telephone', telephone);
  !!email && params.append('email', email);

  return Request.get(`${prefix}`, { params, onlyError: true });
};

/* GET End User Detail */
export const getCustomerDetail = id => {
  return Request.get(`${prefix}/${id}`, { onlyError: true });
};

/* GET End User Agreements list */
export const getCustomerAgreementsList = queries => {
  const { limit, skip, orderBy, sortBy, filter, end_user_id } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  params.append('end_user_id', end_user_id);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!filter && params.append('filter', filter);

  return Request.get(`${agreementPrefix}`, { params, onlyError: true });
};

/* GET End Address list */
export const getCustomerAdressList = queries => {
  const { limit, skip, orderBy, sortBy, title, description, end_user_id } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  params.append('end_user_id', end_user_id);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!title && params.append('title', title);
  !!description && params.append('description', description);

  return Request.get(`${addressPrefix}`, { params, onlyError: true });
};

/* GET End User Pharmacy list */
export const getCustomerPharmacyList = queries => {
  const { limit, skip, orderBy, sortBy, filter, end_user_id } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  params.append('end_user_id', end_user_id);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!filter && params.append('filter', filter);

  return Request.get(`${pharmacyPrefix}`, { params, onlyError: true });
};

/* GET End User Orders List */
export const getCustomerOrdersList = (customerId, queries) => {
  const {
    limit,
    skip,
    orderBy,
    sortBy,
    min_order_date,
    max_order_date,
    order_statuses,
    pharmacy_name,
    order_no
  } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!min_order_date && params.append('min_order_date', min_order_date);
  !!max_order_date && params.append('max_order_date', max_order_date);
  !!order_statuses[0] && params.append('order_statuses[0]', order_statuses[0]);
  !!pharmacy_name && params.append('pharmacy_name', pharmacy_name);
  !!order_no && params.append('order_no', order_no);

  return Request.get(`${orderPrefix}/${customerId}`, { params, onlyError: true });
};

/* GET End User - Support Form List */
export const getCustomerSupportFormList = queries => {
  const { limit, skip, orderBy, sortBy, name, surname, start_date, end_date } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!surname && params.append('surname', surname);
  !!start_date && params.append('start_date', start_date);
  !!end_date && params.append('end_date', end_date);

  return Request.get(`${supportPrefix}`, { params, onlyError: true });
};

/* GET End User - Support Form Detail  */
export const getCustomerSupportFormDetail = id => {
  return Request.get(`${supportPrefix}/${id}`, { onlyError: true });
};
